import { render, staticRenderFns } from "./StickerTabs.vue?vue&type=template&id=0b88409e"
import script from "./StickerTabs.vue?vue&type=script&lang=js"
export * from "./StickerTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports